import { useMemo } from 'react';
import { EntityUserRole } from '@admiin-com/ds-graphql';
import { mergeUniqueItems } from '@admiin-com/ds-common';
import {
  UseEntitiesProps,
  useUserEntities,
} from '../../../hooks/useUserEntities/useUserEntities';

export const useNonAccountEntityUsers = (props?: UseEntitiesProps) => {
  const { users: ownerUsers, loading: ownerLoading } = useUserEntities({
    role: EntityUserRole.OWNER,
    ...props,
  });

  const { users: adminUsers, loading: adminLoading } = useUserEntities({
    role: EntityUserRole.ADMIN,
    ...props,
  });

  const entityUsers = useMemo(
    () =>
      mergeUniqueItems(
        ownerUsers,
        adminUsers,
        ['id', 'entityId'] // unique keys on EntityUser
      ),
    [ownerUsers, adminUsers]
  );

  return {
    entityUsers,
    loading: ownerLoading || adminLoading,
  };
};
